<template>
  <div class="kebab-menu" v-click-outside="onClickOutside" ref="kebabMenu">
    <a href="#" click.prevent :class="setClassModifiers('kebab-menu__icon--')" class="icon-actions d-inline-block kebab-menu__icon" @click="vModel = !vModel"></a>
    <transition name="fade">
      <div class="kebab-menu__dropdown" v-if="vModel">
        <slot v-if="!loading"></slot>
        <spinner width="5" height="3" v-else></spinner>
      </div>
    </transition>
  </div>
</template>

<script>
import Spinner from '@/ui/elements/Spinner'

import setClassModifiers from '@/mixins/setClassModifiers'

import ClickOutside from '@/directives/clickOutside'

export default {
  props: {
    /**
     * @values small
     */
    size: {
      type: String,
      default: null
    },

    loading: {
      type: Boolean,
      default: false
    },

    value: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Spinner
  },

  mixins: [setClassModifiers],

  directives: {
    ClickOutside
  },

  data () {
    return {
      showMenu: false
    }
  },

  computed: {
    vModel: {
      get () {
        if (this.value) {
          return this.value
        }

        return this.showMenu
      },

      set (val) {
        this.showMenu = val
        this.$emit('input', val)
      }
    }
  },

  watch: {
    showMenu (val) {
      this.$emit('input', val)
      if (val) {
        this.setVueScrollerItemZIndex()
      } else {
        this.removeVueScrollerItemZIndex()
      }
    }
  },

  methods: {
    onClickOutside () {
      this.showMenu = false
    },

    setVueScrollerItemZIndex () {
      const el = this.$refs.kebabMenu
      if (el) {
        const closestEl = el.closest('.vue-recycle-scroller__item-view')
        if (closestEl) {
          closestEl.style.zIndex = 1
        }
      }
    },

    removeVueScrollerItemZIndex () {
      const el = this.$refs.kebabMenu
      if (el) {
        const closestEl = el.closest('.vue-recycle-scroller__item-view')
        if (closestEl) {
          closestEl.style.zIndex = null
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .kebab-menu {
    display: inline-block;
    position: relative;

    &__dropdown {
      background: $color-white;
      padding: $default-spacing-mobile;
      overflow: hidden;

      position: absolute;
      z-index: 2;
      top: -2rem;
      right: -1rem;

      @include respond(tab-port) {
        padding: $default-spacing-mobile;
      }

      border-radius: $border-radius;
      border: 1px solid $color-space-lighten;
      box-shadow: 0 0 6px rgba(52, 48, 61, 0.08);
    }

    &__icon {
      font-size: 2.4rem;

      &--small {
        font-size: 2rem;
      }
    }
  }
</style>
